import { Card, DocumentMarkdown } from '@wundo/ui';

/** The run's report in its latest version, or why there is none yet. */
export function RunReportTab({
  report,
  working,
}: {
  report: string | null;
  working: boolean;
}) {
  return (
    <div data-slot='run-report' className='min-h-0 flex-1 overflow-y-auto pb-4'>
      {report ? (
        <Card className='px-8 py-7'>
          <DocumentMarkdown>{report}</DocumentMarkdown>
        </Card>
      ) : (
        <p className='text-base text-ink-muted'>
          {working
            ? 'The analyst is still working on the report.'
            : 'This run has no report.'}
        </p>
      )}
    </div>
  );
}
